const Spinner2 = () => {
  return <div class="lds-dual-ring"></div>;
};

export default Spinner2;
